<template>
    <div>
        <h2>Change name</h2>
        <form @submit.prevent="handleSubmit">
            <div class="form-group">
                <label>Username</label>
<!--                <input type="text" v-model="account.user.firstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && !firstName }" />-->
                <input type="text" v-model="userFirstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && !firstName }" />
<!--                <input type="text" v-model="firstName" name="firstName" class="form-control" :class="{ 'is-invalid': submitted && !firstName }" />-->
<!--                <div v-show="submitted && !firstName" class="invalid-feedback">Username is required</div>-->
            </div>
            <div class="form-group">
                <label>Password</label>
<!--                <input type="text" v-model="account.user.lastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && !lastName }" />-->
                <input type="text" v-model="userLastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && !lastName }" />
<!--                <input type="text" v-model="lastName" name="lastName" class="form-control" :class="{ 'is-invalid': submitted && !lastName }" />-->
<!--                <div v-show="submitted && !lastName" class="invalid-feedback">Password is required</div>-->
            </div>
            <div class="form-group">
                <button class="btn btn-primary">Change data</button>
<!--                <router-link to="/register" class="btn btn-link">Register</router-link>-->
            </div>
        </form>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex'
    import {checkOfflineData} from "@/_helpers";
    // import {mapFields} from "@/_helpers";

    export default {
        data () {
            return {
                firstName: "",
                lastName: "",
                submitted: false
            }
        },

        computed: {
            // ...mapState({
            //     account: state => state.account,

                userFirstName:{
                    get(){
                        return this.$store.state.account.user.firstName;
                    },
                    set(value) {
                        this.$store.commit('account/updateFirstName', value)
                    }
                },
                userLastName:{
                    get(){
                        return this.$store.state.account.user.lastName;
                    },
                    set(value) {
                        this.$store.commit('account/updateLastName', value)
                    }
                }
            // })
        },

        created () {
            checkOfflineData();
        },
        methods: {
            ...mapActions('account', ['updateUserInfo']),
            handleSubmit (e) {
                this.updateUserInfo();

                // Log to avoid ESlint buil error
                console.log(e)
            }
        }
    }
</script>

<style scoped>
    h1 {
        color: blue
    }
</style>
